import { Modal } from 'antd';

const font = { fontFamily: 'CustomFont' };

/** تأیید حذف — یکسان در تمام ایندکس‌های ماژول کار */
export const confirmWorkDelete = ({
  title = 'حذف',
  content,
  okText = 'بله، حذف کن',
  cancelText = 'لغو',
  onOk,
}) =>
  Modal.confirm({
    title: <span style={font}>{title}</span>,
    content: typeof content === 'string' ? <span style={font}>{content}</span> : content,
    okText,
    cancelText,
    okButtonProps: {
      danger: true,
      style: { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' },
    },
    cancelButtonProps: { style: font },
    onOk,
  });
